import React from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import PageLayout from '../components/layout/PageLayout';
import PlaceCreateForm from '../components/places/PlaceCreateForm';
import SocietyContextMobileNav from '../components/societies/SocietyContextMobileNav';

const PlaceCreatePage = () => {
  const { societySlug } = useParams();

  return (
    <PageLayout title="PakPoints">
      <Helmet>
        <title>Add Place - PakPoints</title>
        <meta name="description" content="Add a place of interest to your society" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        {societySlug ? (
          <SocietyContextMobileNav societySlug={societySlug} activeSection="places" />
        ) : null}
        <div className="py-8">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <PlaceCreateForm />
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default PlaceCreatePage;
